import { Component, ChangeDetectorRef, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent {
    window:any= <any>window;
    $:any=<any>this.window.$;
    notification:any = new this.window.HPNotification();

    fileOpener:any = {
        open: function(path, mime = "*/*", name = "") {
            if(!path) return;
            let anchor = window.document.createElement('a');
            anchor.setAttribute('href', path);
            anchor.setAttribute('target', '_blank');
            anchor.setAttribute('download', name);
            window.document.body.appendChild(anchor);
            anchor.click();
            setTimeout(() => {
                anchor.remove();
            }, 100);
        }
    };
    rand = (num:any = null) => {
        num = num || 12;
        var text = "";
        var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < num; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };
    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });
    updateView:any = () => {
        this.zone.run(() => {
            if(!this.queryparams()['type'] || !this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteUserModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#userModal', element: this.elementref.nativeElement }});
                this.initModel();
            }
            if(this.queryparams()['type'] == 'delete' && !!this.queryparams()['user-selected'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#userModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#deleteUserModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'create' && !this.queryparams()['user-selected'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteUserModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#userModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'update' && !!this.queryparams()['user-selected'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteUserModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#userModal', element: this.elementref.nativeElement }});
            }
            this.cd.detectChanges();
        });
    };

    temp:any = {
        filter_text: '',
        password_change: false
    };
    get:any = (public_token:any) => !public_token?
            this.window.usher?.getChildren()?.filter(user => user?.public_configuration?.type == this.params()['users-type'])
            .filter(el => el.public_configuration?.nome?.toLowerCase().includes(this.temp.filter_text.toLowerCase()) || 
                            el.public_configuration?.codice?.includes(this.temp.filter_text) || 
                            el.public_configuration?.indirizzo?.find(e => e.formatted_address.toLowerCase().includes(this.temp.filter_text.toLowerCase())) || 
                            el.public_configuration?.telefono?.includes(this.temp.filter_text) ||
                            el.email?.toLowerCase().includes(this.temp.filter_text.toLowerCase()) || 
                            el.username.toLowerCase().includes(this.temp.filter_text.toLowerCase())) : this.window.usher?.getChildren()?.find(user => user?.public_token == public_token);
    user_model:any = {
        username : "",
        password : "",
        email : "",
        public_configuration : {
            nome : "",                      // nome e cognome
            codice : "",                    // codice fiscale || partita iva
            indirizzo : [],         // { coordinates : [lat, lon], formatted_address : "" }
            note : "",
            giorni_chiusura : [],
            telefono : "",
            groups: [],
            codice_fiscale: "",
            p_iva: ""
        },
        configuration : {},
        token_manager : this.window.usher.getPublicToken()
    };
    array_import:any = [];
    show_import_correct:any = false;
    constructor(
        private cd: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router,
        private elementref: ElementRef,
        private zone: NgZone
    ) {}

    ngAfterViewInit() {
        this.window.scrollTo(0,0);
        this.window.usher.element.addEventListener("change", this.updateView.bind(this));
    
        this.window.__mapsAuxObj.loadedPromise.then(() => {
            let input = this.window.document.querySelector("#indirizzo_autocomplete"),
                autocompleteIndirizzoUtente = new this.window.google.maps.places.Autocomplete(input);
            this.window.google.maps.event.addListener(autocompleteIndirizzoUtente, 'place_changed', () => {
                let model = this.queryparams()['user-selected'] ? this.get(this.queryparams()['user-selected']) || this.user_model : this.user_model;
                model.public_configuration.indirizzo.push({
                    formatted_address : this.getFormattedAddress(autocompleteIndirizzoUtente.getPlace()).formatted_address,
                    coordinates : [autocompleteIndirizzoUtente.getPlace().geometry.location.lat(), autocompleteIndirizzoUtente.getPlace().geometry.location.lng()],
                    id : this.rand()
                });
                input.value = '';
                this.updateView();
            });
        });

        this.route.queryParams.subscribe((p:any) => this.updateView());
    };

    ngOnDestroy() {
        this.window.usher.element.removeEventListener("change", this.updateView.bind(this));
    };

    handleModal = (user:any = undefined, type:any = undefined) => {
        this.router.navigate([`/users/${this.params()['users-title']}/${this.params()['users-type']}`], { queryParams: this.changeQueryParam({ "user-selected" : user, "type" : type }) });
    };

    initModel = () => {
        this.user_model = {
            username : "",
            password : "",
            email : "",
            public_configuration : {
                nome : "",                      // nome e cognome || ragione sociale
                codice : "",                    // codice fiscale || partita iva
                indirizzo : [],         // { coordinates : [lat, lon], formatted_address : "" }
                note : "",
                giorni_chiusura : [],
                telefono : "",
                groups: [],
                codice_fiscale: "",
                p_iva: ""
            },
            configuration : {},
            token_manager : this.window.usher.getPublicToken()
        };
        this.temp.password_change = false;
    };

    getUser:any = () => {
        if(this.queryparams()['user-selected']) return this.get(this.queryparams()['user-selected']) || this.user_model;
        return this.user_model;
    };

    check = (obj:any = this.getUser()) => {
        if (!obj.username) {
            this.notification.danger({ text: 'Inserire campo username!' });
            return false;
        }
        if (!obj.public_token && !obj.password) {
            this.notification.danger({ text: 'Inserire campo password!' });
            return false;
        }
        if (!!obj.password && obj.password.length < 8) {
            this.notification.danger({ text: 'La password deve contenere almeno 8 caratteri!' });
            return false;
        }
        if (!obj.public_configuration.nome) {
            this.notification.danger({ text: 'Inserire nome!' });
            return false;
        }
        //if (!model.public_configuration.telefono) return this.notification.danger({ text: 'Inserire telefono!' });
        if (!obj.email) {
            this.notification.danger({ text: 'Inserire email!' });
            return false;
        }
        //if (!model.public_configuration.codice) return this.notification.danger({ text: 'Inserire codice!' });
        //if (obj.public_configuration.type == 'cliente' && !obj.public_configuration.indirizzo.length) return this.notification.danger({ text: 'Inserire indirizzo!' });
        return true;
    };
    
    handleUser = async () => {
        if(!this.check()) return;
        if(this.queryparams()['user-selected']) {
            try {
                await this.getUser().update();
                this.handleModal(undefined, undefined);
                this.notification.success({text: 'User aggiornato con successo'});
            } catch(e) {
                console.log(e);
            }
            this.handleModal(undefined, undefined);
            return;
        }
        try {
            this.getUser().public_configuration.type = this.params()['users-type'];
            if(!!this.temp.password_change) {
                await this.window.sf.utils.$http({
                    method: 'POST',
                    url: `${this.window.appInfo.url_php}/endpoint.php/user`,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        private_token : this.window.usher.getPrivateToken(),
                        type: "add_user",
                        password_change: true,
                        user: this.getUser()
                    }
                });
            } else await this.window.usher.addUser(this.getUser());
            this.handleModal(undefined, undefined);
            this.notification.success({text: 'User creato con successo'});
        } catch(e) {
            console.log(e);
            this.notification.danger({text: 'Attenzione! Username o email potrebbero già essere utilizzati.'});
        };
        return;
    };

    delete = async () => {
        try {
            await this.getUser()?.delete();
            this.notification.success({text: 'User cancellato con successo'});
            this.handleModal(undefined, undefined);
        } catch(e) {
            console.log(e);
        }
    };

    // funzione ausiliaria per l'autocomplete
    getFormattedAddress = (place) => {
        //@params: place - Google Autocomplete place object
        //@returns: location_obj - An address object in human readable format
        let location_obj = {
            formatted_address: ""
        };
        for (let i in place.address_components) {
            let item = place.address_components[i];

            location_obj.formatted_address = place.formatted_address;
            if (item['types'].indexOf("locality") > -1) {
                location_obj['locality'] = item['long_name']
            } else if (item['types'].indexOf("administrative_area_level_1") > -1) {
                location_obj['admin_area_l1'] = item['short_name']
            } else if (item['types'].indexOf("street_number") > -1) {
                location_obj['street_number'] = item['short_name']
            } else if (item['types'].indexOf("route") > -1) {
                location_obj['route'] = item['long_name']
            } else if (item['types'].indexOf("country") > -1) {
                location_obj['country'] = item['long_name']
            } else if (item['types'].indexOf("postal_code") > -1) {
                location_obj['postal_code'] = item['short_name']
            }

        }
        return location_obj;
    };

    deleteAddress = (i:any) => {
        if(isNaN(i) || i<0) return;
        this.getUser().public_configuration.indirizzo.splice(i, 1);
        this.cd.detectChanges();
    };

    addGroup = (event:any) => {
        this.getUser().public_configuration.groups = this.getUser().public_configuration.groups || [];
        if(!event.target.value || !!this.getUser().public_configuration.groups.find(e => e.id == event.target.value)) return;
        this.getUser().public_configuration.groups.push(this.window.usher.get().public_configuration.groups.find(e => e.id == event.target.value));
    };
    
    /*--------------------GESTIONE IMPORT UTENTI--------------------------------*/

    openImport = () => {
        this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#importModal', element: this.elementref.nativeElement }});
    };

    closeImport = () => {
        this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#importModal', element: this.elementref.nativeElement }});
        this.array_import.length = 0;
        this.show_import_correct = false;
    };

    downloadEsempioImport = async () => {
        const path = `${this.window.appInfo.url_app}/esempio_import_utenti.xlsx`,
            name = `esempio_import_utenti.xlsx`;
        if(!path) return;
        try {
            await this.fileOpener.open(path, '*/*', name);
        } catch(e) {
            console.log(e);
            this.notification.danger({text: "Errore! Riprova più tardi."});
        }
    };

    getImportDocument = async (ev:any) => {
        let parsed = [];
        try {
            parsed = (await this.window.parserHP.parseFile(ev.target, {
                method: 'posizionale',
                header_map: {
                    0: 'username',
                    1: 'password',
                    2: 'email',
                    3: 'telefono',
                    4: 'codice_fiscale',
                    5: 'p_iva',
                    6: 'nome',
                    7: 'codice',
                    8: 'change_password'
                }
            }))?.data || [];
        } catch(e) {
            console.log(e);
            return this.notification.danger({text: "Errore. Riprova più tardi."});
        }

        for(let i=parsed.length-1; i>=0; i--) {
            let current = parsed[i];
            try {
                await this.window.usher.checkUsername({
                    username: current.username,
                    email: current.email
                }, false);
            } catch(e) {
                parsed.splice(i, 1);
                console.log(e);
            }
        }
        this.array_import.push(...parsed);
        this.show_import_correct = true;
    };

    uploadImport = async () => {
        for(let i=0; i<this.array_import.length; i++) {
            let current = this.array_import[i];
            try {
                let user = {
                    username : current.username,
                    password : current.password,
                    email : current.email,
                    public_configuration : {
                        nome : current.nome,                      // nome e cognome || ragione sociale
                        codice : current.codice,                    // codice fiscale || partita iva
                        indirizzo : [],         // { coordinates : [lat, lon], formatted_address : "" }
                        note : "",
                        giorni_chiusura : [],
                        telefono : current.telefono,
                        groups: [],
                        codice_fiscale: current.codice_fiscale,
                        p_iva: current.p_iva,
                        type: this.params()['users-type']
                    },
                    configuration : {},
                    token_manager : this.window.usher.getPublicToken()
                };

                if(!this.check(user)) continue;

                if(!!current.change_password) {
                    await this.window.sf.utils.$http({
                        method: 'POST',
                        url: `${this.window.appInfo.url_php}/endpoint.php/user`,
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        data: {
                            private_token : this.window.usher.getPrivateToken(),
                            type: "add_user",
                            password_change: true,
                            user: user
                        }
                    });
                } else await this.window.usher.addUser(user);
            } catch(e) {
                console.log(e);
            }
        }
        this.notification.success({text: 'Utenti caricati con successo'});
        this.closeImport();
    };
}